import { useEffect, useRef } from "react";
import { findDOMNode } from "react-dom";
import { About, Contact, Footer, Header, Hero, Portfolio, Skill, Statistic } from '../components';

const Landing = () => {
    const refHeader = useRef();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (refHeader) {
      const navLinks = findDOMNode(refHeader.current).children[1].children;

      for (let i = 0; i < navLinks.length; i++) {
        navLinks[i].addEventListener("click", function (e) {
          const href = e.target.getAttribute("href");
          const tujuan = document.querySelector(href);

          window.scrollTo({ top: tujuan.offsetTop - 190, behavior: "smooth" });

          e.preventDefault();
        });
      }

      window.addEventListener('scroll', () => {
        const scroll = window.pageYOffset

        for (let i = 0; i < navLinks.length; i++) {
          const element = navLinks[i]
          const href = element.getAttribute('href')
          const tujuan = document.querySelector(href);

          if (scroll >= tujuan.offsetTop -190) {
            for (let j = 0; j < navLinks.length; j++) {
              navLinks[j].classList.remove('active')
            }
            element.classList.add('active')
          }
        }
      })
    }
  }, []);

    return (
        <>
        <Header ref={refHeader} />
        <Hero/>
        <About/>
        <Statistic/>
        <Skill/>
        <Portfolio/>
        <Contact/>
        <Footer/>
        </>
    )
}

export default Landing